import axios from 'axios'
import Config from 'config'

// Dedicated axios instance for the standalone PESTEL backend.
//
// We deliberately do NOT use the global `axios` singleton: its default headers
// carry Regul's `Authorization: Token <key>` and `Workspace: <id>`, which must
// never be sent to another host. This instance has its own baseURL and attaches
// the acting user's Regul token per-request. PESTEL verifies that token against
// Regul server-side (users/me) and authorizes workspace-Owner-only actions.
const pestelApi = axios.create({
  baseURL: `${Config.pestel.url.replace(/\/$/, '')}/api`
})

pestelApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('authToken')
  if (token) {
    cfg.headers = cfg.headers || {}
    cfg.headers.Authorization = `Token ${token}`
  }
  return cfg
})

export default pestelApi
